import { CircularProgress, Skeleton, Stack, Typography } from "@mui/material";
import React, { useEffect } from "react";

interface TelehealthImageProps {
  currentImage: string
  scale?: number
  translateX?: number
  translateY?: number
  isDragging?: boolean
  height?: number
}

const TelehealthImage: React.FC<TelehealthImageProps> = ({
  currentImage,
  scale = 1,
  translateX = 0,
  translateY = 0,
  isDragging = false,
  height = 80
}) => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [imageError, setImageError] = React.useState<boolean>(false);
  const [selectedImage, setSelectedImage] =
    React.useState<string>(currentImage);

  useEffect(() => {
    if (currentImage !== selectedImage) {
      setLoading(true);
      setSelectedImage(currentImage || "");
    }
  }, [currentImage]);

  const OnLoadEnd = () => {
    setLoading(false);
    setImageError(false);
  };

  const OnError = () => {
    setLoading(false);
    setImageError(true);
  };

  return (
    <div>
      {loading && (
        <Stack
          height={`${height}vh`}
          alignContent={"center"}
          justifyContent={"center"}>
          <CircularProgress />
        </Stack>
      )}
      <img
        src={currentImage}
        loading="eager"
        alt="Uploaded"
        onLoad={OnLoadEnd}
        onError={OnError}
        style={{
          transformOrigin: "center center",
          transform: `scale(${scale}) translate(${translateX}px, ${translateY}px)`,
          transition: isDragging ? "none" : "transform 0.1s ease-out",
          display: loading ? "none" : undefined,
          height: `${height}vh`,
        }}
      />
      {imageError && <Typography variant="body1">Image Expired</Typography>}
    </div>
  );
};

export default TelehealthImage;
